import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { LeaderboardWithRecentResults } from '../models/LeaderboardWithRecentResults';
import driverApi from '../clients/DriverClient';
import ResultsTable from './shared/ResultsTable';
import EmptyState from './EmptyState';

const LatestResults = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const [results, setResults] = useState<LeaderboardWithRecentResults | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const count = searchParams.get('count');

    useEffect(() => {
        const fetchData = async () => {
            if (!id) return;
            try {
                setIsLoading(true);
                const data = await driverApi.getRecentResultsById(id, count);
                setResults(data);
            } catch (error) {
                console.error("Fetch error:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [id, count]);

    return (
        <main>
            <article>
                {isLoading ? (
                    <EmptyState message="Loading recent results..." animate={true} />
                ) : (
                    <ResultsTable results={results} showDate={false} />
                )}
            </article>
        </main>
    );
};

export default LatestResults;
